/**
 * Labels for the payment method recorded on a funnel event.
 *
 * Deliberately NOT parsePaymentMethodName. That one maps the NUMERIC codes invoices use (0, 4), while
 * bot_funnel_event.payment_method is a varchar(30) written by @Enumerated(EnumType.STRING) - the enum
 * NAME. Feeding these names to the numeric helper returns an empty string for every row, so the table
 * would render a blank first column and still look like it worked.
 *
 * The labels mirror PaymentMethodEnum's own display strings so the funnel names a method the same way the
 * rest of the product does.
 */
const FUNNEL_PAYMENT_METHOD_LABELS: Record<string, string> = {
  PIX: 'Pix',
  ITP: 'Pix Instantâneo',
  CREDIT_CARD: 'Cartão de Crédito',
  CRIPTO: 'Cripto',
  FREE: 'Plano Gratuito',
  MERCADO_PAGO: 'Mercado Pago',
  PIC_PAYA: 'PicPay',
  HOTMART: 'Hotmart',
  EDUZZ: 'Eduzz',
};

/**
 * Unknown names fall through unchanged rather than becoming blank.
 *
 * A method added to the bot before this map is updated must still be readable: the raw name tells a
 * producer something, an empty cell tells them the report is broken.
 */
export const parseFunnelPaymentMethod = (paymentMethod: string) =>
  FUNNEL_PAYMENT_METHOD_LABELS[paymentMethod] ?? paymentMethod;
